import { FormattedMessage } from 'react-intl'
import FooterText from 'src/Components/homeSearch/HomeSearchFooter/FooterText/FooterText'
import Disclaimer from 'src/Components/shared/Disclaimer'
import HousingType from 'src/Components/shared/HousingType'
import { Text } from 'src/Components'
import styles from './MobileListingDetailsFooter.module.scss'
import DataSourceDisclaimer from '../../../HomeSearchFooter/DataSourceDisclaimer'
import { ListingMetadata } from '../../../Compliance/ListingMetadata'
import { ListingDataRequiredByListingsMetadata } from '../../../Compliance/ListingMetadata/ListingMetadata'
import { StateSpecificFooterLinks } from 'src/Components/homeSearch/Compliance/StateSpecificFooterLinks'

interface ListingDetailsFooterProps {
  listing: ListingDataRequiredByListingsMetadata
}

export const MobileListingDetailsFooter = ({
  listing,
}: ListingDetailsFooterProps) => {
  const DisclaimersHeadingText = () => (
    <Text
      element='h2'
      size='l'
      variant='neutralCool'
      variantCount='900'
      weight='bold'
      align='left'
      className={styles.heading}
    >
      <FormattedMessage
        id='HomeSearch.footer.disclaimers'
        defaultMessage='Disclaimers'
      />
    </Text>
  )

  return (
    <footer className={styles.root}>
      <div className={styles.listingMetadataWrapper}>
        <ListingMetadata listing={listing} />
      </div>

      <div>
        <DisclaimersHeadingText />
        <Disclaimer className={styles.disclaimer} staticContext={undefined} />
        <div className={styles.disclaimer}>
          <DataSourceDisclaimer />
        </div>
        <div className={styles.stateSpecificSection}>
          <StateSpecificFooterLinks align='left' />
        </div>
      </div>

      <div>
        <HousingType className={styles.housingType} />
        <FooterText className={styles.footerText} />
      </div>
    </footer>
  )
}
